<template>
  <h2 class="section-subheader">{{ header }}</h2>

  <DataTable
    :value="value"
    class="rate-detail-table p-datatable-sm datatable-no-header"
    auto-layout
  >
    <Column field="k" header-style="display:none;" />
    <Column header-style="display:none;">
      <template #body="{ data }">
        <InfoIcon
          v-if="data?.toolTipText"
          class="text-warning"
          :icon="data.tooltipIcon"
          :tooltip="data?.tooltipText"
        />
      </template>
    </Column>
    <Column field="v" header-style="display:none;">
      <template #body="{ data }">
        <template v-if="typeof data.v === 'string'">{{ data.v }}</template>
        <component :is="data.v" v-else />
      </template>
    </Column>
  </DataTable>
</template>

<script lang="ts" setup>
import { PropType, toRefs, VNode } from 'vue';

import InfoIcon from '@rygen/rygen-ui/components/ui/InfoIcon.vue';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';

export type RateQuoteDetails = {
  k: string;
  v: string | (() => VNode);
  tooltipIcon?: `pi ${string}`;
  tooltipText?: string;
};

const props = defineProps({
  header: {
    type: String,
    required: true,
  },
  value: {
    type: Array as PropType<RateQuoteDetails[]>,
    default: () => [],
  },
});
const { header, value } = toRefs(props);
</script>
